import moment from "moment";
import { Card, CardHeader, Badge, CardBody, Button } from "reactstrap";

import { OrganisationSchedule } from "../../interfaces/models/Organisation";

import "../../assets/css/kanban-design.css";
import { MAX_TIMING_PER_DAY } from "../../helper/constants";

interface Props {
  times: OrganisationSchedule[];
  days: string[];
  hasCRUD: boolean;
  loading: boolean;
  handleOpenEditSchedulerModal?: (schedule: OrganisationSchedule) => void;
  handleOpenDeleteModal?: (schedule: OrganisationSchedule) => void;
  handleOpenAddSchedulerModal?: (index: number) => void;
}

export default function CompanyNudgePlanKanban({ times, days, hasCRUD, loading, handleOpenDeleteModal, handleOpenEditSchedulerModal, handleOpenAddSchedulerModal }: Props) {

  const dateNow = moment().format("yyyy-MM-DD");
  const inputFormat = "yyyy-MM-DD HH:mm";

  const getScheduledTimesInDay = (day: number) => {
    return times.filter(u => u.day === day);
  }

  return (
    <div className="kanban-scroller">
      {
        days.map((day, index) => {

          const timesInDay= getScheduledTimesInDay(index + 1);
          const timeCount = timesInDay.length;

          return (
            <Card key={day} className={`shadow-dark-em h-100 ${index !== 0 ? "ml-2" : ""}`}>
              <CardHeader tag="h5" className="text-center mb-0">{day} <Badge color="info">{timeCount}/2</Badge> </CardHeader>
              <CardBody >

                {
                  timesInDay.map((u, index) => (
                    <div className="shadow-darker border rounded p-2 bg-white mb-2 d-flex justify-content-between" key={index}>
                      <span>{moment(dateNow + " " + u.time, inputFormat).format("hh:mm A")} </span>
                      {
                        hasCRUD && 
                        <div>
                          <small title="Edit" onClick={() => handleOpenEditSchedulerModal(u)} className="text-primary mr-2" role="button" ><i className="fas fa-edit"></i></small>
                          <small title="Delete" onClick={() => handleOpenDeleteModal(u)} className="text-danger" role="button" ><i className="fas fa-trash-alt"></i></small>
                      </div>  
                      }
                    </div>
                  ))
                }
                {
                  hasCRUD && timeCount !== MAX_TIMING_PER_DAY &&
                  <Button 
                    className="w-100" 
                    size="sm" 
                    onClick={() => handleOpenAddSchedulerModal(index + 1)} 
                    color="primary"
                    disabled={loading}
                  > 
                    <i className="fas fa-plus"></i> Add
                  </Button>
                }
                
              </CardBody>
            </Card>
          )
        })
      }
    </div>
  )
}

